<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const form = useForm({
    email: "",
})

const notify = useNotification()

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

function submit() {
    form.post("subscribers").then((response) => {
        form.reset()
        notify("positive", response.message)
    })
}
</script>

<template>
    <div class="tw-flex tw-flex-col">
        <div class="tw-relative">
            <div
                class="tw-w-full tw-bg-secondary lg:tw-grid lg:tw-grid-cols-2 prefooter-container !tw-overflow-hidden tw-relative"
            >
                <div
                    class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-z-10 tw-gap-5 tw-h-[420px] max-container lg:tw-hidden"
                >
                    <h3
                        class="tw-font-poppins tw-text-center sm:tw-text-start tw-font-semibold tw-text-customGray-700 tw-text-[40px] sm:tw-text-[64px] tw-leading-[60px] sm:tw-leading-[96px]"
                    >
                        {{ $t("pre_footer.title") }}
                    </h3>
                    <p
                        class="tw-font-poppins tw-text-center sm:tw-text-start tw-text-white tw-font-medium tw-text-2xl tw-leading-9"
                    >
                        {{ $t("pre_footer.subtitle") }}
                    </p>
                </div>
                <div
                    class="tw-flex tw-justify-end tw-w-full tw-h-max lg:tw-h-full tw-z-20 lg:tw-col-start-2"
                >
                    <img
                        src="/img/pre-footer-img.webp"
                        class="tw-w-full tw-border-4 tw-border-green-400 lg:tw-object-right tw-object-contain"
                        alt=""
                    />
                </div>
            </div>
            <div
                class="tw-hidden tw-text-white tw-font-bold tw-text-[60px] lg:tw-text-[72px] tw-absolute max-container tw-gap-8 tw-inset-0 lg:tw-flex tw-flex-col tw-justify-center"
            >
                <div
                    class="tw-flex tw-flex-col tw-justify-center tw-gap-4 tw-w-1/2 tw-pr-8"
                >
                    <h3
                        class="tw-text-start tw-font-semibold tw-text-customGray-700 tw-text-[64px] tw-leading-[96px]"
                    >
                        {{ $t("pre_footer.title") }}
                    </h3>
                    <p
                        class="tw-text-start tw-text-white tw-font-medium tw-text-2xl tw-leading-9"
                    >
                        {{ $t("pre_footer.subtitle") }}
                    </p>
                </div>
            </div>
        </div>
        <div class="tw-bg-primary-300">
            <div
                class="tw-w-full lg:tw-h-[116px] max-container tw-flex tw-flex-col tw-items-center lg:tw-flex-row lg:tw-justify-between lg:tw-items-center tw-gap-5 tw-py-6 lg:tw-py-0"
            >
                <div
                    class="tw-flex tw-flex-col tw-items-center lg:tw-flex-row lg:tw-gap-6"
                >
                    <img
                        src="/img/mail.svg"
                        class="tw-w-[68px] tw-h-[68px]"
                        alt=""
                    />
                    <div
                        class="tw-flex tw-flex-col tw-items-center lg:tw-items-start lg:tw-justify-evenly"
                    >
                        <h4
                            class="tw-leading-[30px] tw-text-primary tw-font-semibold tw-text-xl"
                        >
                            {{ $t("pre_footer.contact.title") }}
                        </h4>
                        <h6 class="tw-text-white tw-leading-6">
                            {{ $t("pre_footer.contact.subtitle") }}
                        </h6>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-justify-start">
                    <q-form
                        class="tw-bg-white tw-py-1 tw-px-1 tw-text-customGray-500 tw-rounded-full tw-w-full sm:tw-w-[520px] tw-h-[38px] tw-flex tw-justify-between"
                    >
                        <q-input
                            class="tw-ml-6 tw-self-center tw-w-full"
                            :label="$t('fields.email')"
                            v-model="form.email"
                            :error="form.errors.email"
                            type="email"
                            @update:model-value="form.errors.email = undefined"
                            required
                            borderless
                        />
                        <button
                            type="button"
                            @click="submit"
                            class="tw-bg-primary tw-text-white tw-rounded-full tw-font-medium tw-text-xs tw-leading-4 tw-uppercase tw-px-5"
                        >
                            {{ $t("pre_footer.contact.button") }}
                        </button>
                    </q-form>
                    <span
                        class="tw-text-negative tw-ml-6"
                        v-if="form.errors.email"
                        >{{ form.errors.email[0] }}</span
                    >
                </div>
                <Brands color="primary" />
            </div>
        </div>
    </div>
</template>

<style>
.prefooter-container::before {
    content: "";
    background: url("/img/banner-img.svg") no-repeat;
    @apply tw-w-full lg:tw-w-[500px] tw-absolute tw-left-0 tw-top-0 lg:tw-top-[10%] lg:tw-bottom-0 tw-aspect-square tw-opacity-20;
}
</style>
